import * as React from 'react';
import { Text } from 'ilenia';
import { css, StyleSheet } from 'aphrodite';
import { Flex, Box } from '../../CommonUI/Layout';
import { Modal, TrustpilotSpinner } from '../';
import { checkTemporaryConfig } from '../../Api/settingsApiClient';
import * as images from '../../Assets/images/svg';
import { SIGNUP_EMAIL_KEY } from '@trustpilot/ecommscript-integrationappauth';

interface AppLockProps {
    integrationKey: string;
}

interface AppLockState {
    lock: boolean;
    loading: boolean;
    success: boolean;
}

export class AppLock extends React.Component<AppLockProps, AppLockState> {
    private mounted = true;

    public constructor(props: AppLockProps) {
        super(props);
        this.state = {
            loading: true,
            lock: false,
            success: false,
        };

        this.handleOnWindowFocus = this.handleOnWindowFocus.bind(this);
        this.checkIntegrationKeyExists = this.checkIntegrationKeyExists.bind(this);
        this.onSuccessModalClose = this.onSuccessModalClose.bind(this);
    }

    public componentDidMount() {
        this.checkIntegrationKeyExists(false);
        window.addEventListener('visibilitychange', this.handleOnWindowFocus);
    }

    public componentWillUnmount() {
        this.mounted = false;
        window.removeEventListener('visibilitychange', this.handleOnWindowFocus);
    }

    public handleOnWindowFocus() {
        const { lock } = this.state;
        if (lock) {
            this.checkIntegrationKeyExists(true);
        }
    }

    public checkIntegrationKeyExists(showSuccess: boolean) {
        this.setState({ loading: true }, async () => {
            const response = await checkTemporaryConfig(this.props.integrationKey);
            if (response && response.exists === true) {
                if (this.mounted) {
                    this.setState({ lock: true, loading: false });
                }
            } else {
                if (this.mounted) {
                    this.setState({ lock: false, loading: false, success: showSuccess });
                }
            }
        });
    }

    public onSuccessModalClose() {
        this.setState({ success: false });
    }

    public onWrongEmailClicked() {
        window.location.href = '/signup';
    }

    public getSignupEmail() {
        let signupEmail: string = '';
        try {
            signupEmail = localStorage.getItem(SIGNUP_EMAIL_KEY) || '';
        } catch (e) { /* empty by purpose */ }
        return signupEmail ? signupEmail : <Text id="modal.appLockEmailNotFound" />;
    }

    public render() {
        const { lock, loading, success } = this.state;
        return (
            <React.Fragment>
                <Modal
                    isOpen={lock}
                    mainActionButton={{
                        children: undefined,
                    }}
                    nonClosingActionButton={{
                        children: <Text id="modal.wrongEmail"/>,
                        onClick: this.onWrongEmailClicked,
                    }}
                    header={<React.Fragment><Text id="modal.appLockHeader"/></React.Fragment>}
                >
                    {loading ?
                        <TrustpilotSpinner active={loading} height="140px"/> :
                        <div>
                            <p className={css(styles.textGroup)}>
                                <Text id="modal.appLockThanks"/>
                                <br/>
                                <Text id="modal.appLockCheckEmail"/>
                            </p>
                            <p className={css(styles.textGroup)}>
                                <Text id="modal.appLockEmailStart"/><b>{this.getSignupEmail()}</b><Text id="modal.appLockEmailEnd"/>
                                <br/>
                                <Text id="modal.appLockWait"/>
                            </p>
                            <p className={css(styles.textGroup)}>
                            <Text id="modal.appLockActivate"/>
                            </p>
                        </div>
                    }
                </Modal>
                <Modal
                    isOpen={success}
                    mainActionButton={{
                        children: <Text id="modal.appLockSuccessClose"/>,
                        onClick: this.onSuccessModalClose
                    }}
                    header={
                        <Flex flexDirection={'row'}  alignItems="center">
                            <Box width="auto" mr={10} ml={16} mt="10px">
                                <images.checked/>
                            </Box>
                            <Text id="modal.appLockSuccessHeader"/>
                        </Flex>}
                    onClose={this.onSuccessModalClose}
                    closable={true}
                >
                    <div>
                        <p className={css(styles.textGroup)}>
                            <Text id="modal.appLockPluginReady"/>
                        </p>
                        <p className={css(styles.textGroup)}>
                            <Text id="modal.appLockYouCanAlso"/>
                            <br/>
                            - <Text id="modal.appLockReviewInvitations"/>
                            <br/>
                            - <Text id="modal.appLockReviewProduct"/>
                            <br/>
                            - <Text id="modal.appLockReviewOther"/>
                        </p>
                    </div>
                </Modal>
            </React.Fragment>
        );
    }
}

const styles = StyleSheet.create({
    textGroup: {
        fontSize: '14px',
        fontFamily: 'Lato',
        margin: '0 0 24px 0',
        fontWeight: 'normal',
        color: '#292929',
        lineHeight: '1.43',
    },
});



// WEBPACK FOOTER //
// ./src/CommonUI/Control/AppLock.tsx